(ns common.schema.entities.note
  (:require [common.schema.entities.related-entities :as related-entities]
            [common.schema.entities.activity :as activity]))

(defonce import-fixed-fields [:note/message])

(def new-note
  (concat [[:note/message {:field/data-type             :data.type/text-richtext
                           :field/default-authorization {:access/read  :role/guest-buy-side
                                                         :access/write :role/guest-buy-side}
                           :field/default-visibility    {:editor :editor.type/none
                                                         :grid   :editor.type/none
                                                         :filter :filter.type/text
                                                         :field-visibility :in-use-disabled}
                           :field/translations          {:en "Message"}}]]
          activity/new-activity
          related-entities/related-entities))
